import { defineComponent as _defineComponent } from 'vue'
import { useGoogleSetup } from '@/composables/useGoogleSetup';
import { useCalendars } from '@/store/useCalendars';
import { usePrivate } from '@/store/usePrivate';
import { useTrainers } from '@/store/useTrainers';
import { getAdminCalendars } from '@/util/functions';
import { dataInstanceToData } from '@busy-human/gearbox';
import { ManagementCalendars, ManagementTrainers } from '@busy-human/k9-library';
import { computed, onMounted, ref } from 'vue';
import ColorSelector from "../sub-component/color-selector.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'manage-calendars-modal',
  setup(__props, { expose: __expose }) {
  __expose();

const tabs = {
	"main":	 { title: "Main", state: "main" },
	"list": { title: "Trainers", state: "list" },
};

const manageCalendarState = ref<"loading" | "main" | "list">("list");
const userCalendarsLoaded = ref(false);
const userCalendars = ref<ManagementCalendars.Model[] | null>(null);
const errMessages = ref<null|string>(null);

// --- Main Calendar Functionality
const calendarStore = useCalendars();
const privateStore = usePrivate();
const { doLinkGoogle, doUnlinkGoogle, loading: googleLoading } = useGoogleSetup();

async function loadUserCalendars() {
	const {data: cals} = await getAdminCalendars();
	userCalendars.value = cals;
	userCalendarsLoaded.value = true;
}
onMounted(async () => {
	await loadUserCalendars();
});

// --- Main Calendar
async function performMainSet(cal: ManagementCalendars.Model) {
	manageCalendarState.value = 'loading';
	await calendarStore.setMainCalendar(cal);
	await calendarStore.refreshCalendars();
	manageCalendarState.value = 'main';
}
async function performMainUnset() {
	manageCalendarState.value = 'loading';
	await calendarStore.clearMain();
	await calendarStore.refreshCalendars();
	manageCalendarState.value = 'main';
}

// --- Trainer List Functionality
const trainerStore = useTrainers();
const trainerList = computed(() => [...trainerStore.trainers.values()].sort((a, b) => a.email.localeCompare(b.email)));

const editTrainerId = ref<string | null>(null);
const addNewTrainer = ref(false);
const workingTrainer = ref<ManagementTrainers.Model | null>(null);
const trainerWorking = ref(false);

function updateColor(color:string|any) {
	if(workingTrainer.value) {
		workingTrainer.value.calendarColor = color;
		console.log( "working trainer set: ", workingTrainer.value);
	} else {
		console.log( "working trainer had no value: ", workingTrainer.value);
	}
};

function startNewTrainer() {
	addNewTrainer.value = true;
	editTrainerId.value = null;
	workingTrainer.value = ManagementTrainers.Defaults();
}

function editTrainer(id: string) {
	const tmp = trainerStore.trainers.get(id);
	if(!tmp) throw new Error("Trainer not found");
	editTrainerId.value = id;
	addNewTrainer.value = false;
	workingTrainer.value = dataInstanceToData(tmp);
}

async function deleteTrainer(id: string) {
	// TODO: Confirmation?
	trainerWorking.value = true;
	await trainerStore.deleteTrainer(id);
	trainerWorking.value = false;
}

async function submitTrainer() {

	try {
		if(!workingTrainer.value) throw new Error("No details");
		trainerWorking.value = true;
		if(editTrainerId.value) {
			await trainerStore.updateTrainer(editTrainerId.value, workingTrainer.value);
		} else {
			await trainerStore.addTrainer(workingTrainer.value);
		}
		// eslint-disable-next-line require-atomic-updates
		editTrainerId.value = null;
		addNewTrainer.value = false;
		errMessages.value = "";
	} catch (e: any) {
		console.error(e);

		if( e.toString().includes("Invalid email")) {
			errMessages.value = "Invalid Email entered";

		} else if( e.toString().includes("Error: User with that email does not exist!")) {
			errMessages.value = "Error: User with that email does not exist";
		} else {
			errMessages.value = `Unknown error: ${e}`;
		}
	} finally {
		trainerWorking.value = false;
	}
}

const back = () => {
	trainerWorking.value = false;
	addNewTrainer.value  = false;
	errMessages.value = "";
};


const __returned__ = { tabs, manageCalendarState, userCalendarsLoaded, userCalendars, errMessages, calendarStore, privateStore, doLinkGoogle, doUnlinkGoogle, googleLoading, loadUserCalendars, performMainSet, performMainUnset, trainerStore, trainerList, editTrainerId, addNewTrainer, workingTrainer, trainerWorking, updateColor, startNewTrainer, editTrainer, deleteTrainer, submitTrainer, back, get useGoogleSetup() { return useGoogleSetup }, get useCalendars() { return useCalendars }, get usePrivate() { return usePrivate }, get useTrainers() { return useTrainers }, get getAdminCalendars() { return getAdminCalendars }, get dataInstanceToData() { return dataInstanceToData }, get ManagementCalendars() { return ManagementCalendars }, get ManagementTrainers() { return ManagementTrainers }, computed, onMounted, ref, ColorSelector }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})